import React from "react";
import styled from "styled-components";

const Hidden = styled.div`
  display: none;
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    display: ${({ $showOnPhone }) => ($showOnPhone ? "contents" : "none")};
  }
  @media (min-width: ${({ theme }) =>
      parseInt(theme.breakpoints.phone) + 1}px) and (max-width: ${({ theme }) =>
      theme.breakpoints.wideTablet}) {
    display: ${({ $showOnTablet }) => ($showOnTablet ? "contents" : "none")};
  }
  @media (min-width: ${({ theme }) =>
      parseInt(theme.breakpoints.wideTablet) + 1}px) {
    display: ${({ $showOnDesktop }) => ($showOnDesktop ? "contents" : "none")};
  }
`;

export default Hidden;

export const HiddenOnPhone = ({ ...props }) => (
  <Hidden
    $showOnDesktop={true}
    $showOnTablet={false}
    $showOnPhone={false}
    {...props}
  />
);

export const HiddenOnDesktop = ({ ...props }) => (
  <Hidden
    $showOnDesktop={false}
    $showOnTablet={true}
    $showOnPhone={true}
    {...props}
  />
);
